// Get current time-based greeting
export const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 17) return 'Good Afternoon';
  return 'Good Evening';
};

/** Returns the user's IANA timezone (e.g. "America/New_York"). */
export const getUserTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

/** Escapes square brackets in user input to prevent argument injection in slash commands. */
export const sanitizeCommandInput = (input: string): string =>
  input.replace(/[[\]]/g, '');